import { Slider, Select, Button } from "antd";
import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { PlaybackContext } from "../LayoutPlayback";
import { FormControl, IconButton, InputLabel, MenuItem } from "@mui/material";
import PauseIcon from "@mui/icons-material/Pause";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import { PLAYBACK_ENUM, SPEED_OPTIONS } from "../utils/layoutPlaybackConfig";
import moment from "moment";

const ControlSlider = ({ seekVal, handleSeekChange }) => {
  const slider = seekVal * 100;
  return (
    <Slider
      value={slider}
      onChange={(newVal) => {
        handleSeekChange(newVal / 100);
      }}
      aria-label="Default"
      style={{}}
    />
  );
};
function PlaybackControls() {
  const {
    controls,
    updateControls,
    handleControlAction,
    queryParams,
    serverClock,
    handlePlayPause,
    handleSeekSpeedChange,
    handleRestartClick,
    resetSVG,
  } = useContext(PlaybackContext);

  const { play, seek } = controls;
  const is_playing = useMemo(() => {
    return PLAYBACK_ENUM.PLAYING === play;
  }, [controls.play]);

  const handlePlayClick = () => {
    if (play === PLAYBACK_ENUM.PLAYING) {
      updateControls("key", { key: "play", value: PLAYBACK_ENUM.PAUSED });
      handlePlayPause({ Pause: true });
    }
    if (play === PLAYBACK_ENUM.PAUSED) {
      updateControls("key", { key: "play", value: PLAYBACK_ENUM.PLAYING });
      handlePlayPause({ Play: true });
    }
  };

  return (
    <div className="layout-playback-controls">
      <ControlSlider
        seekVal={seek}
        handleSeekChange={(newSeek) => {
          resetSVG();
          updateControls("key", { key: "seek", value: newSeek });
          handleSeekSpeedChange({ seek: newSeek, speed: controls.speed });
        }}
      />
      <div className="control-btns">
        <div className="control-btns-group-1">
          <IconButton style={{ color: "white" }} onClick={handlePlayClick}>
            {is_playing ? <PauseIcon /> : <PlayArrowIcon />}
          </IconButton>
          <div className="time">
            <div className="date-time">
              {serverClock ? (
                <>
                  <div className="time">{serverClock ? moment(serverClock).format("HH:mm:ss") : "NA"} </div>
                  <div className="date">{serverClock ? moment(serverClock).format("DD-MM-YYYY") : "NA"} </div>
                </>
              ) : (
                <div>NA</div>
              )}
              {}
            </div>
            <div className="sep">
              <div>/</div>
              <div>/</div>
            </div>
            <div className="date-time">
              <div className="time">{moment(queryParams.to_ts).format("HH:mm:ss")}</div>
              <div className="date">{moment(queryParams.to_ts).format("DD-MM-YYYY")}</div>
            </div>
          </div>
          <div className="speed-selector">
            <span>Speed :</span>
            <Select
              value={Number(controls.speed)}
              placement="topLeft"
              dropdownStyle={{ zIndex: 9999 }} // Custom zIndex
              style={{ width: "90px" }}
              onChange={(newSpeed) => {
                updateControls("key", { key: "speed", value: Number(newSpeed) });
                handleSeekSpeedChange({ seek: controls.seek, speed: Number(newSpeed) });
              }}
              options={SPEED_OPTIONS}
            />
          </div>
        </div>
        <div className="control-btns-group-2">
          <Button onClick={handleRestartClick}>Start Again</Button>
          <Button
            onClick={() => {
              window.close();
            }}
            color="danger"
            variant="solid"
          >
            Exit
          </Button>
        </div>
      </div>
    </div>
  );
}

export default PlaybackControls;
